module.exports = __webpack_public_path__ + "img/02 Aniamtion 3-squashed.d7a0cd1b.jpg";